module.exports = __webpack_public_path__ + "img/login_bg.dac611e4.png";